import { FilterChip, Flex, Text } from 'pcln-design-system'
import { getFilterId } from '../helpers'
import React from 'react'

const StopsFilterChips = ({ stops, handleChange, hide2Stops }) => {
  const filters = hide2Stops ? /* istanbul ignore next */ stops.filter((stop) => stop.value !== '7') : stops

  return (
    <Flex flexDirection={'column'}>
      {filters?.map((stop, index) => {
        const id = getFilterId(`stops`, index, stop?.value)
        return (
          <FilterChip
            width={1}
            id={id}
            key={id}
            data-testid={id}
            onClick={() => {
              handleChange({
                [stop?.value]: !stop.checked,
              })
            }}
            disabled={stop.disabled}
            m={null}
            selected={stop?.checked}
            index={index}
            mb='4px'
            mt={index !== 0 ? 1 : null}
          >
            <Flex width={1} m={2}>
              <Text fontSize={0} regular data-testid={id + '-text'}>
                {stop?.primaryLabel}
              </Text>
              {stop?.secondaryLabel ? (
                <Text fontSize={0} regular ml={'auto'} data-testid={id + '-label'}>
                  {stop.secondaryLabel}
                </Text>
              ) : null}
            </Flex>
          </FilterChip>
        )
      })}
    </Flex>
  )
}

export default StopsFilterChips
